<template>
  <apexchart
    type="line"
    height="350"
    :options="impressionsChartOptions"
    :series="item"
  ></apexchart>
</template>
<script>
export default {
  props: {
    series: Array,
    header: Array
  },
  data() {
    return {
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },
          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: "datetime",
          categories: []
        },
        grid: {
          borderColor: "#f1f1f1"
        },
        colors: ["#3AB8FF", "#FF7B00"]
      },
      chartOptions: {
        chart: {
          id: "vuechart-example"
        },
        xaxis: {
          categories: []
        }
      },
      item: [
        {
          name: "Impresiones.",
          data: [0]
        },
        {
          name: "Alcance.",
          data: [0]
        }
      ]
    };
  },
  watch: {
    series: {
      handler(data) {
        this.item = data;
      },
      deep: true
    },
    header: {
      handler(data) {
        this.impressionsChartOptions = {
          xaxis: {
            categories: data
          }
        };
      },
      deep: true
    }
  }
};
</script>
